module.exports = __webpack_public_path__ + "0aecb0069ed3ddcc74780e95d349e7a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/hotline.png
// module id = 692
// module chunks = 54 55 56 79 80 88